module.exports = __webpack_public_path__ + "img/freelance-market-place.cb00c44b.svg";